export const SAVE_USER_INFO = "SAVE_USER_INFO";
export const SAVE_FISCAL_YEAR = "SAVE_FISCAL_YEAR";
export const SAVE_USER_PERMISSIONS = "SAVE_USER_PERMISSIONS";
export const SAVE_HEALTH_CLIENT_INFO = "SAVE_HEALTH_CLIENT_INFO";
export const RESET_PAGE_NUMBER = "RESET_PAGE_NUMBER";
export const SAVE_MEDICINE_INFO = "SAVE_MEDICINE_INFO";
export const ADD_MEDICINE_DETAIL = "ADD_MEDICINE_DETAIL";
export const SAVE_REGISTER_SHOW_HIDE_INFO = "SAVE_REGISTER_SHOW_HIDE_INFO";
export const SAVE_LAB_TEST_ITEMS = "SAVE_LAB_TEST_ITEMS";
export const SET_FROM_DATE = "SET_FROM_DATE"
export const SET_TO_DATE = "SET_TO_DATE"
export const SEARCH_PARAMS = "SEARCH_PARAMS"
export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER";
export const SET_ROWS_PER_PAGE = "SET_ROWS_PER_PAGE";
export const SET_NOTIFICATION_DATA = "SET_NOTIFICATION_DATA";